export default {
  state: {
    data: {},
    permissions: null,
  },
  mutations: {},
  getters: {
    userinfo(state) {
      return state.data;
    }
  },
  actions: {}
};
